/**
 * Created by Carsten Bühler
 * User: c.buehler on 09.06.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Container, FormControl, FormGroup, FormLabel } from 'external/react-bootstrap';
import { Title, translation, ValidationMessage } from 'plugin/liferay-widgets-react-web';

class LogicLayerEditForm extends React.Component {

    componentDidMount() {
        const { formData } = this.props;
        return this.props.onChange(formData, this.validate(formData));
    }

    onChange(field, e) {
        let formData = this.props.formData,
            item = formData.item || formData;

        let newData = {
            ...item,
            [ field ]: e.target.value
        };

        return this.props.onChange(newData, this.validate(newData));
    }

    validate(formData) {
        let titleValid, descriptionValid;

        if (!(formData.title && formData.title.length > 0)) {
            titleValid = 'Bitte Titel eingeben';
        }

        if ((formData.title && formData.title.length > 0 && !/\S/.test(formData.title))) {
            titleValid = 'Titel darf nicht mit einem leerzeichen starten!';
        }

        if ((formData.title && formData.title.length > 0) && !(formData.title.length <= 75)) {
            titleValid = 'Titel zu lang. Maximal 75 Zeichen.';
        }

        if ((formData.description && formData.description.length > 0 && !/\S/.test(formData.description))) {
            descriptionValid = 'Beschreibung darf nicht mit einem leerzeichen starten!';
        }

        if ((formData.description && formData.description.length > 0) && !(formData.description.length <= 75)) {
            descriptionValid = 'Beschreibung zu lang. Maximal 75 Zeichen.';
        }

        return {
            title: titleValid,
            description: descriptionValid
        };
    }

    render() {
        let { formData, formValidation } = this.props,
            item = formData.item || formData;

        return (
            <Container className="py-3">
                <Title title={ translation.trans('edit-logic-layer') }/>
                <FormGroup controlId="title">
                    <FormLabel>{ translation.trans('title') + '*' }</FormLabel>
                    <FormControl type="text" name="title"
                                 placeholder={ translation.trans('title') }
                                 value={ item.title || '' }
                                 onChange={ this.onChange.bind(this, 'title') }
                                 required/>
                    <ValidationMessage formValidation={ formValidation } propName="title"/>
                </FormGroup>
                <FormGroup controlId="description">
                    <FormLabel>{ translation.trans('description') }</FormLabel>
                    <FormControl type="text" name="description"
                                 placeholder={ translation.trans('description') }
                                 value={ item.description || '' }
                                 onChange={ this.onChange.bind(this, 'description') }/>
                    <ValidationMessage formValidation={ formValidation } propName="description"/>
                </FormGroup>
            </Container>
        );
    }
}

LogicLayerEditForm.propTypes = {
    formData: PropTypes.object,
    formValidation: PropTypes.object,
    onChange: PropTypes.func.isRequired
};

export default LogicLayerEditForm;




// WEBPACK FOOTER //
// ./js/components/LogicLayerEditForm.jsx